export const isNativeApp = !!window.android || !!window.webkit;

/**
 * True when running inside the iOS wrapper, which exposes WKWebView's
 * `window.webkit.messageHandlers` bridge.
 */
export const isIosApp = !window.android && !!window.webkit?.messageHandlers;
